import { render, staticRenderFns } from "./TerminologieVignette.vue?vue&type=template&id=3c74b2fc&scoped=true"
import script from "./TerminologieVignette.vue?vue&type=script&lang=js"
export * from "./TerminologieVignette.vue?vue&type=script&lang=js"
import style0 from "./TerminologieVignette.vue?vue&type=style&index=0&id=3c74b2fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c74b2fc",
  null
  
)

export default component.exports